// extracted by mini-css-extract-plugin
export var container = "PrintRecipe-module--container--WDF66";
export var imageWrapper = "PrintRecipe-module--imageWrapper--hJiBP";
export var ingredientsContainer = "PrintRecipe-module--ingredientsContainer--7+tv0";
export var insideImageWrapper = "PrintRecipe-module--insideImageWrapper--SPL5o";
export var textField = "PrintRecipe-module--textField--IrVmv";